<template>
<div>
  
<!-- 内容 -->
 <div class="warpper">
    <!-- 缓存首页 -->
    <keep-alive>
      <router-view v-if="$route.name === 'home'" />
    </keep-alive>
    <!-- 不缓存其他页面 -->
    <router-view v-if="$route.name !== 'home'" />
  </div>
</div>
</template>

<script>
// import Header from './Header.vue';
export default {
    name: 'contentIndex',  // 修改为多词的组件名称
    props: {

  },
methods:{
    changMenu(){
        this.$emit('changeShow')
    }
}
}
</script>

<style>

.warpper{
    padding: 10px;
    min-height: 800px;
}

/* 响应式适配 - 移动端 */
@media (max-width: 768px) {
.warpper{
    padding-top: 65px;
}


}
</style>